/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
import {
  flowIdSalesConversation,
  flowIdRiskAnalysisBE,
  flowIdRiskAnalysisNL,
  flowIdRiskAnalysisShortBE,
  flowIdCompanyScanBE,
  flowIdCompanyScanNL,
  flowIdDeMotoVerzekering,
  flowIdVillasureOfferFlow,
  flowIdVillasureContractFlow,
  flowIdPiaBoatOfferFlow,
  flowIdPiaBoatContractFlow,
  flowIdBikmoOfferFlow,
  flowIdBikmoContractFlow,
  flowIdCyclingVlaanderenContractFlowId,
  flowIdCyclingVlaanderenOfferFlowId,
  flowIdShortCheckupCompanyNL,
  flowIdShortCheckupCustomerNL,
  flowIdShortCheckupCompanyBE,
  flowIdShortCheckupCustomerBE,
  flowIdCfVerzekeringen,
  flowIdAskaTravelContract,
  flowIdAskaTravelOffer,
  flowIdGoudseCompanyScan,
} from '../../constants/flowIds';
import { FlowsQuestion } from '../../types/FlowsTypes';
import riskAnalysisComponents from './RiskAnalysisComponents';
import advisoryFlowInputComponents from './AdvisoryFlowInputComponents';
import companyScanInputComponents from './CompanyScanInputComponents';
import { Inputs } from '../../types/Enums';
import MaskedInputComponent from './company-scan-inputs/masked/MaskedInputComponent';

export interface InputProps {
  question: FlowsQuestion;
}

export const flowInputComponents = {
  [flowIdRiskAnalysisNL]: riskAnalysisComponents,
  [flowIdRiskAnalysisBE]: riskAnalysisComponents,
  [flowIdRiskAnalysisShortBE]: riskAnalysisComponents,
  [flowIdSalesConversation]: advisoryFlowInputComponents,
  [flowIdCompanyScanBE]: companyScanInputComponents,
  [flowIdCompanyScanNL]: companyScanInputComponents,
  [flowIdGoudseCompanyScan]: companyScanInputComponents,
  [flowIdDeMotoVerzekering]: advisoryFlowInputComponents,
  [flowIdVillasureOfferFlow]: advisoryFlowInputComponents,
  [flowIdVillasureContractFlow]: advisoryFlowInputComponents,
  [flowIdPiaBoatOfferFlow]: advisoryFlowInputComponents,
  [flowIdPiaBoatContractFlow]: advisoryFlowInputComponents,
  [flowIdShortCheckupCompanyNL]: {
    ...advisoryFlowInputComponents,
    [Inputs.MASKED]: (props: InputProps) => <MaskedInputComponent {...props} />,
  },
  [flowIdShortCheckupCompanyBE]: {
    ...advisoryFlowInputComponents,
    [Inputs.MASKED]: (props: InputProps) => <MaskedInputComponent {...props} />,
  },
  [flowIdShortCheckupCustomerNL]: advisoryFlowInputComponents,
  [flowIdShortCheckupCustomerBE]: advisoryFlowInputComponents,
  [flowIdCfVerzekeringen]: advisoryFlowInputComponents,
  [flowIdAskaTravelContract]: advisoryFlowInputComponents,
  [flowIdAskaTravelOffer]: advisoryFlowInputComponents,
  [flowIdBikmoOfferFlow]: advisoryFlowInputComponents,
  [flowIdBikmoContractFlow]: advisoryFlowInputComponents,
  [flowIdCyclingVlaanderenContractFlowId]: advisoryFlowInputComponents,
  [flowIdCyclingVlaanderenOfferFlowId]: advisoryFlowInputComponents,
};

export const getFlowInputComponents = (flowId: string) => {
  return flowInputComponents[flowId] || advisoryFlowInputComponents;
};
